<sera-dropdown
    #versionModel="ngModel"
    [styleClass]="'old-version-dropdown'"
    [panelStyleClass]="'old-version-dropdown__panel'"
    (selectionChanged)="emitSelectedOption($event); versionModel.reset(selectedOptionKey)"
    [isFiltered]="false"
    [options]="options"
    [ngModel]="selectedOptionKey"
    [showClear]="false">
</sera-dropdown>
